module.exports = __webpack_public_path__ + "assets/img/hour_glass.d4238e97.svg";